import { useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import PageLoader from "../../../../../../../components/PageLoader";
import { selectListItems } from "../../../../../../../redux/library/selector";
import Table from "../../../../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";
import { smsPlans } from "../../../../../../../redux/sms-plans/action";
import { selectSmsPlansListItems } from "../../../../../../../redux/sms-plans/selector";

const ListSmsPlans = ({
  choosenSmsTemplate,
  selectedPlanId,
  setSelectedPlanId,

}: any) => {
  const dispatch = useAppDispatch();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectSmsPlansListItems);
  const libraryData = useSelector(selectListItems);
  const [columnDefs, setColumnDefs] = useState<any>([]);

  useEffect(() => {
    if (choosenSmsTemplate?.EmailPlanId > 0) {
      setSelectedPlanId(choosenSmsTemplate?.EmailPlanId);
    }
  }, [choosenSmsTemplate]);

  useEffect(() => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer: (params: any) => parseInt(params.node.id, 10) + 1,
      },

      { field: 'Name', headerName: 'Plan' },
        {
        field: 'FrequencyId',
        headerName: 'Frequency',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.CampaignFrequency },
      },
      { field: 'StartDate', headerName: 'Start Date', isDateValueFormat: true },
      { field: 'EndDate', headerName: 'End Date', isDateValueFormat: true },
     {
        field: 'CampaignTypeId',
        headerName: 'Campaign Type',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.CampaignType },
      },
    ]);
  }, [selectedPlanId, libraryData]);


  const handleSelect = useCallback((planIdArr: any) => {
    const selectedPlan = itemsData?.result?.items?.find(
      (item: any) => item.Id === planIdArr[0]?.Id
    );


    setSelectedPlanId(selectedPlan);

  }, [itemsData]);

  const fetchPlan = () => {
    dispatch(
      smsPlans.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/sms-plans/list`,
        entity: 'smsPlans',
        jsonData: {
          PageNumber: pageData,
          PageSize: pageSize,
        },
      })
    );
  };

  useEffect(() => {
    fetchPlan();
  }, [pageData, pageSize]);

  return (
    <>
      {itemsData?.isLoading ? (
        <PageLoader />
      ) : (
        <Table
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          headingName="Plans"
          onSelect={handleSelect}
          checkboxConfig={{
            allowMultiSelect: false,
            defaultSelectedIds: selectedPlanId ? selectedPlanId : '',
            isDisabled: false,
            keyColumn: 'Id',

          }}
        />
      )}
    </>
  );
};

export default ListSmsPlans;
